import { RadioChangeEvent } from 'antd';
import React, { useState } from 'react';
import { IngestionSourceList } from './source/IngestionSourceList';
import { SecretsList } from './secret/SecretsList';
import { SearchHeader } from '../search/SearchHeader';
import BreadcrumbContextProvider from '../search/context/BreadcrumbContextProvider';
import { IngestionTabType } from '../shared/admin/HeaderLinks';

export const ManageIngestionPage = () => {
    /**
     * Determines which view should be visible: ingestion sources or secrets.
     */
    const [selectedTab, setSelectedTab] = useState<IngestionTabType>(IngestionTabType.Sources);

    const handleModeChange = (e: RadioChangeEvent) => {
        setSelectedTab(e.target.value);
    };

    return (
        <>
            <BreadcrumbContextProvider>
                <SearchHeader
                    subtext="Create, schedule, and run Data Catalog ingestion pipelines."
                    ingestionTabType={selectedTab}
                    handleIngestionModeChange={handleModeChange}
                />
            </BreadcrumbContextProvider>
            {selectedTab === IngestionTabType.Sources ? <IngestionSourceList /> : <SecretsList />}
        </>
    );
};
